module.exports = __webpack_public_path__ + "img/lk-phone.d512e329.svg";